import RewardsIconSchema from "@apps/rewards/schemas/RewardsIconSchema";
import { RewardsDiscountCodeRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsDiscountRewardSchema";
import { RewardsFreeProductDiscountCodeRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { RewardsGiftCardBalanceRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsGiftCardRewardSchema";
import {
    array,
    assign,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES } from "../types";
import { RewardsCustomerRewardsActivitySchema } from "./RewardsCustomerRewardsActivitySchema";

export const RewardsCustomerDiscountCodeRewardSchema = assign(
    RewardsDiscountCodeRewardSchema,
    object({
        endsAt: nullable(string()),
        minOrderAmount: nullable(number()),
        maxShippingPrice: nullable(number()),
        countryCodes: nullable(array(string())),
        usageLimit: nullable(number()),
        usageCount: number(),
    })
);

const RewardsCustomerFreeProductDiscountCodeRewardSchema = assign(
    RewardsFreeProductDiscountCodeRewardSchema,
    object({
        endsAt: nullable(string()),
    })
);

const RewardsCustomerActiveRewardsBaseSchema = object({
    id: number(),
    reward: union([
        RewardsCustomerDiscountCodeRewardSchema,
        RewardsCustomerFreeProductDiscountCodeRewardSchema,
        RewardsGiftCardBalanceRewardSchema,
    ]),
    createdAt: string(),
});

const RewardsCustomerActiveRewardsEarningRuleSchema = assign(
    RewardsCustomerActiveRewardsBaseSchema,
    object({
        type: literal(REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES.reward),
        earningRule: RewardsCustomerRewardsActivitySchema,
    })
);

const RewardsCustomerActiveRewardsSpendingRuleSchema = assign(
    RewardsCustomerActiveRewardsBaseSchema,
    object({
        type: literal(REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES.redeem),
        spendingRule: RewardsCustomerRewardsActivitySchema,
    })
);

const RewardsCustomerActiveRewardsTierSchema = assign(
    RewardsCustomerActiveRewardsBaseSchema,
    object({
        type: literal(REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES.tier),
        tier: RewardsCustomerRewardsActivitySchema,
    })
);

const RewardsCustomerActiveRewardsReferredSchema = assign(
    RewardsCustomerActiveRewardsBaseSchema,
    object({
        type: literal(REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES.referred),
        referred: object({
            title: string(),
            icon: nullable(RewardsIconSchema),
        }),
    })
);

const RewardsCustomerActiveRewardsReferrerSchema = assign(
    RewardsCustomerActiveRewardsBaseSchema,
    object({
        type: literal(REWARDS_CUSTOMER_ACTIVE_REWARDS_TYPES.referrer),
        referrer: object({
            title: string(),
            icon: nullable(RewardsIconSchema),
        }),
    })
);

export const RewardsCustomerActiveRewardsSchema = union([
    RewardsCustomerActiveRewardsEarningRuleSchema,
    RewardsCustomerActiveRewardsSpendingRuleSchema,
    RewardsCustomerActiveRewardsTierSchema,
    RewardsCustomerActiveRewardsReferredSchema,
    RewardsCustomerActiveRewardsReferrerSchema,
]);

export const RewardsCustomerActiveRewardsResponseSchema = object({
    rewards: array(RewardsCustomerActiveRewardsSchema),
});
